import convertPxToNum from '../../util/convertPxToNum';
import SPACING from './spacing';

// typeface
const FONT_FAMILY_CIRCULAR = "'circular', serif";
const FONT_FAMILY_PROXIMA = "'proxima-nova', 'Helvetica', Arial, sans-serif";
const FONT_FAMILY_NEW_SPIRIT = "'new-spirit', serif";
const FONT_FAMILY_SANS_SERIF = FONT_FAMILY_CIRCULAR;
const FONT_FAMILY_SERIF = FONT_FAMILY_NEW_SPIRIT;

/* Font sizes */
const FONT_SIZE_EXTRA_SMALL = '12px';
const FONT_SIZE_SMALLER = '14px';
const FONT_SIZE_SMALL = '16px';
const FONT_SIZE_REGULAR = '20px';
const FONT_SIZE_LARGE = '24px';
const FONT_SIZE_LARGER = '32px';
const FONT_SIZE_SEMI_LARGE = '48px'; // DEPRECATED
const FONT_SIZE_SEMI_HUGE = '48px';
const FONT_SIZE_HUGE = '56px';

// Font Weight
const FONT_WEIGHT_REGULAR = '400';
const FONT_WEIGHT_MEDIUM = '500';
const FONT_WEIGHT_SEMI_BOLD = '600';
const FONT_WEIGHT_BOLD = '700';

const textSizeRegular = (fontSize: string, important?: boolean): string => `
  font-size: ${fontSize}${important ? '!important' : ''};
  line-height: ${convertPxToNum(fontSize) + convertPxToNum(SPACING.SM)}px${
  important ? '!important' : ''
};
`;

const textSizeCompact = (fontSize: string, important?: boolean): string => `
  font-size: ${fontSize}${important ? '!important' : ''};
  line-height: ${convertPxToNum(fontSize) + convertPxToNum(SPACING.XS)}px${
  important ? '!important' : ''
};
`;

const textSizeUltraCompact = (fontSize: string, important?: boolean): string => `
  font-size: ${fontSize}${important ? '!important' : ''};
  line-height: ${convertPxToNum(fontSize) + convertPxToNum(SPACING.XXS)}px${
  important ? '!important' : ''
};
`;

const FONT = {
  FONT_FAMILY_CIRCULAR,
  FONT_FAMILY_NEW_SPIRIT,
  FONT_FAMILY_PROXIMA,
  FONT_FAMILY_SANS_SERIF,
  FONT_FAMILY_SERIF,
  FONT_SIZE_EXTRA_SMALL,
  FONT_SIZE_HUGE,
  FONT_SIZE_LARGE,
  FONT_SIZE_LARGER,
  FONT_SIZE_REGULAR,
  FONT_SIZE_SEMI_LARGE,
  FONT_SIZE_SEMI_HUGE,
  FONT_SIZE_SMALL,
  FONT_SIZE_SMALLER,
  FONT_WEIGHT_BOLD,
  FONT_WEIGHT_MEDIUM,
  FONT_WEIGHT_REGULAR,
  FONT_WEIGHT_SEMI_BOLD,
  textSizeCompact,
  textSizeRegular,
  textSizeUltraCompact,
  SIZE: {
    EXTRA_SMALL: FONT_SIZE_EXTRA_SMALL,
    SMALLER: FONT_SIZE_SMALLER,
    SMALL: FONT_SIZE_SMALL,
    REGULAR: FONT_SIZE_REGULAR,
    LARGE: FONT_SIZE_LARGE,
    LARGER: FONT_SIZE_LARGER,
    SEMI_HUGE: FONT_SIZE_SEMI_HUGE,
    HUGE: FONT_SIZE_HUGE,
  },
  FAMILY: {
    SERIF: FONT_FAMILY_SERIF,
    SANS_SERIF: FONT_FAMILY_SANS_SERIF,
    CIRCULAR: FONT_FAMILY_CIRCULAR,
  },
  WEIGHT: {
    BOLD: FONT_WEIGHT_BOLD,
    SEMI_BOLD: FONT_WEIGHT_SEMI_BOLD,
    REGULAR: FONT_WEIGHT_REGULAR,
    MEDIUM: FONT_WEIGHT_MEDIUM,
  },
};

export default FONT;
